import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3e0424f1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3e0424f1&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0424f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e0424f1')) {
      api.createRecord('3e0424f1', component.options)
    } else {
      api.reload('3e0424f1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3e0424f1&scoped=true", function () {
      api.rerender('3e0424f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin/components/Breadcrumb/index.vue"
export default component.exports